import { Invitation } from '@domain/invitation';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { GET_EVENT_INVITATIONS } from './type';

export const getInvitationQueryKey = (eventId: string) => [GET_EVENT_INVITATIONS, eventId];

const getInvitationsByEventId = async (eventId: string) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/events/${eventId}/admissions/invitations`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetEventInvitations = ({ eventId }: { eventId: string }) => {
  return useGenericQuery<Invitation[], RequestError>(
    getInvitationQueryKey(eventId),
    () => getInvitationsByEventId(eventId),
    { enabled: !!eventId }
  );
};
